<template>
  <div class="select-list-container">
    <ul v-if="items.length" class="select-list">
      <li v-if="isMultiSelect && items.length > 1"
          @click.stop="selectAll">
        <IhuCheckbox class="select-list-checkbox"
                     :state="allSelectedFlag">
          Select all
        </IhuCheckbox>
      </li>
      <li v-for="item in items"
          :key="item[itemIdAttr]"
          :data-testid="`ihu-widget-select-item-${item[itemValueAttr]}`"
          :disabled="item.disabled"
          @click.stop="onItemClicked(item)">
        <IhuCheckbox v-if="isMultiSelect"
                     class="select-list-checkbox"
                     :disabled="item.disabled"
                     :state="isSelected(item)">
          {{ item[itemValueAttr] }}
        </IhuCheckbox>
        <span v-else>{{ item[itemValueAttr] }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { IhuCheckbox } from '@/components/common';

  const CHECKBOX_STATES = {
    UNCHECKED: 'unchecked',
    CHECKED: 'checked',
    INDETERMINATE: 'indeterminate',
  };

  export default {
    name: 'ihu-select-list',
    components: {
      IhuCheckbox,
    },
    props: {
      itemIdAttr: {
        type: String,
        default: 'id',
      },
      itemValueAttr: {
        type: String,
        default: 'value',
      },
      isMultiSelect: {
        type: Boolean,
        default: false,
      },
      isAllSelected: {
        type: Boolean,
        default: false,
      },
      items: {
        type: Array,
        default: () => ([]),
      },
      selectedItems: {
        type: Array,
        default: () => ([]),
      },
    },
    computed: {
      allSelectedFlag() {
        if (this.isAllSelected) {
          return CHECKBOX_STATES.CHECKED;
        } else if (this.selectedItems.length) {
          return CHECKBOX_STATES.INDETERMINATE;
        }
        return CHECKBOX_STATES.UNCHECKED;
      },
    },
    methods: {
      onItemClicked(item) {
        if (!item.disabled) {
          this.$emit('itemClicked', item);
        } else {
          this.$emit('disabledItemClicked', item);
        }
      },
      selectAll() {
        this.$emit('selectAllItems', !this.isAllSelected);
      },
      isSelected(item) {
        return !!this.selectedItems.find(si => si[this.itemIdAttr] === item[this.itemIdAttr]);
      },
    },
  };
</script>

<style scoped lang="scss">
  .select-list-container {
    height: 0;
    position: absolute;
    width: calc(100% - 2px);
    bottom: -1px;
    z-index: 100;

    .select-list {
      position: absolute;
      max-height: 256px;
      min-width: 100%;
      overflow: auto;

      border-width: 1px;
      border-top-width: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      border-style: solid;
      border-color: transparent;

      @include themify {
        background: getColor('ihu-select-list-bg', 'ihu');
      }

      & > li {
        display: flex;
        flex-direction: row;
        padding-left: 12px;
        align-items: center;
        min-height: 38px;

        &:is([disabled]) {
          opacity: 0.53;
        }

        &:not([disabled]) {
          cursor: pointer;
        }

        &:hover {
          @include themify {
            background: getColor('ihu-select-list-active-bg', 'ihu');
          }
        }
      }
    }

    /deep/ .ihu-checkbox .label {
        font-size: $font-size-medium;
        padding-left: 4px;
    }

    /deep/ .ihu-checkbox.select-list-checkbox {
      display: flex;
      align-items: center;

      .indicator {
        margin-right: 4px;
        border-width: 2px !important;
        background: transparent !important;
        @include themify {
          border-color: getColor('ihu-select-checkbox-border', 'ihu');
        }

        &:hover {
          background: transparent !important;
          @include themify {
            border-color: getColor('ihu-select-checkbox-border', 'ihu');
          }
        }

        &.checked {
          @include themify {
            border-color: getColor('ihu-select-checkbox-bg', 'ihu') !important;
            background-color: getColor('ihu-select-checkbox-bg', 'ihu') !important;

            &::after {
              border-color: getColor('ihu-select-checkbox-intermediate-bg', 'ihu') !important;
            }
          }
        }

        &.indeterminate {
          @include themify {
            border-color: getColor('ihu-select-checkbox-bg', 'ihu') !important;
            background-color: getColor('ihu-select-checkbox-bg', 'ihu') !important;

            &::after {
              background-color: getColor('ihu-select-checkbox-intermediate-bg', 'ihu') !important;
            }
          }
          &::after {
            left: 2px;
            top: 5px;
            width: 8px;
            height: 2px;
          }
        }
      }
    }
  }
</style>
